import React, { useState, useRef, useEffect } from "react";
import PrintOrderScreen from "./PrintOrderScreen";
import Swal from "sweetalert2";

function TopBarAfterUpload({
  openFileDialog,
  sortOrder,
  onSortChange,
  onSelectAll,
  allSelected,
  photos,
  quantities,
  setQuantities,
  onQuickOrder,
  onReviewOrder,
}) {
  const [showQuickOrder, setShowQuickOrder] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();

  const options = [
    { value: "UPLOAD", label: "Default Upload Order" },
    { value: "AZ", label: "Ascending by Filename" },
    { value: "ZA", label: "Descending by Filename" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ✅ Handle Review Order Button Click
  const handleReviewOrderClick = () => {
    const hasSelectedSize = Object.values(quantities).some((photoSizes) =>
          Object.values(photoSizes).some((qty) => qty > 0)
        );
    
        if (!hasSelectedSize) {
          Swal.fire({
            icon: "warning",
            title: "No Size Selected",
            text: "Please select at least one print size before proceeding.",
            confirmButtonText: "OK",
          });
          return; // stop navigation
        }
    
        // ✅ Proceed only if size selected
        onReviewOrder();
  };

  return (
    <>
      <header className="top-bar">
        <div className="left-buttons">
          <i className="fa-solid fa-arrow-left back-button" style={{ color: "white", marginTop: "6px" }} onClick={() => {window.location.href = "https://opticonframing.com.au/order-prints/";}}></i>
          <div className="divider" id="divider-top"></div>
          <button onClick={openFileDialog} className="add-button">
            <span className="icon-box">
              <i className="fa-solid fa-camera-retro" style={{ marginRight: "8px" }}></i>
            </span>
            <span className="btn-text">ADD PHOTOS</span>
          </button>
          <button className="add-button" onClick={onQuickOrder}>
            <i className="fa-solid fa-bolt" style={{ marginRight: "6px" }}></i>
            QUICK ORDER
          </button>
        </div>

        <div className="right-buttons">
          <label className="select-all" style={{ cursor: "pointer" }}>
            <span style={{ marginLeft: "6px" }}>Select All</span>
            <button
              onClick={() => onSelectAll(!allSelected)}
              className="toggle-btn"
              style={{
                background: "transparent",
                border: "none",
                color: "white",
                fontSize: "22px",
                cursor: "pointer",
              }}
            >
              <i
                className={`fa-solid ${allSelected ? "fa-toggle-on" : "fa-toggle-off"}`}
              ></i>
            </button>
          </label>

          {/* Custom dropdown */}
          <div className="custom-dropdown" ref={dropdownRef}>
            <button
              className="dropdown-toggle"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              SORT
              <i
                className={`fa-solid fa-chevron-${dropdownOpen ? "up" : "down"}`}
                style={{ marginLeft: "6px" }}
              ></i>
            </button>

            {dropdownOpen && (
              <ul className="dropdown-menu">
                {options.map((opt) => (
                  <li
                    key={opt.value}
                    onClick={() => {
                      onSortChange(opt.value);
                      setDropdownOpen(false);
                    }}
                    className={sortOrder === opt.value ? "active" : ""}
                  >
                    {sortOrder === opt.value && (
                      <i className="fa-solid fa-check" style={{ color: "#1e5fff" }}></i>
                    )}
                    <span>{opt.label}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="divider"></div>

          {/* ✅ Updated button with validation */}
          <button className="add-button" onClick={handleReviewOrderClick}>
            <i className="fa-solid fa-cart-shopping" style={{ marginRight: "6px" }}></i>
            NEXT: REVIEW & ORDER
          </button>
        </div>
      </header>
    </>
  );
}

export default TopBarAfterUpload;